var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.1976C0 7.53619 0.536186 7 1.1976 7H9.58084C10.2423 7 10.7784 7.53619 10.7784 8.1976V16.5808C10.7784 17.2423 10.2423 17.7784 9.58084 17.7784H1.1976C0.536186 17.7784 0 17.2423 0 16.5808V8.1976Z",
    fill: "#EA5356"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1189 8.20901C29.1189 7.54129 29.6602 7 30.3279 7H38.791C39.4587 7 40 7.54129 40 8.20901V16.6721C40 17.3398 39.4587 17.8811 38.791 17.8811H30.3279C29.6602 17.8811 29.1189 17.3398 29.1189 16.6721V8.20901Z",
    fill: "#0A1F3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1189 22.7171C29.1189 22.0494 29.6602 21.5081 30.3279 21.5081H38.791C39.4587 21.5081 40 22.0494 40 22.7171V31.1802C40 31.8479 39.4587 32.3892 38.791 32.3892H30.3279C29.6602 32.3892 29.1189 31.8479 29.1189 31.1802V22.7171Z",
    fill: "#0A1F3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6108 8.20901C14.6108 7.54129 15.1521 7 15.8198 7H24.2829C24.9506 7 25.4919 7.54129 25.4919 8.20901V31.1802C25.4919 31.8479 24.9506 32.3892 24.2829 32.3892H15.8198C15.1521 32.3892 14.6108 31.8479 14.6108 31.1802V8.20901Z",
    fill: "#0A1F3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbLogo);
export default __webpack_public_path__ + "static/media/tb-logo.ce236a79.svg";
export { ForwardRef as ReactComponent };